import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weather-type-radio-active",
  "use": "icon-weather-type-radio-active-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-weather-type-radio-active\"><rect x=\".352\" width=\"16\" height=\"16\" rx=\"8\" fill=\"#4066D4\" /><circle cx=\"8.352\" cy=\"8\" r=\"3\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol